import styled from 'styled-components';

export const ToastsWrapper = styled.div(({ theme: { size } }) => ({
  boxSizing: 'border-box',
  padding: '0',
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(2),
}));
